import { Button, ButtonProps } from '../../../views/Button';
import classNames from 'classnames';
type Props = ButtonProps & {
    selected?: boolean;
};
export function ThermometerButton({ selected, className, ...props }: Props) {
    return (
        <Button
            {...props}
            variant="thermometer"
            className={classNames(className, {
                'btn-thermometer-active': selected,
            })}
        />
    );
}
